<template>
  <div class="modal-holder">
    <div class="modal" :class="{'js-active': isOpen}">
      <div class="modal__top">
        <slot name="top"></slot>
        <a class="modal__closer" @click.prevent.stop="onClose">
          <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              preserveAspectRatio="xMinYMin"
          >
            <use xlink:href="#icon_cross"></use>
          </svg>
        </a>
      </div>
      <div class="modal__bottom">
        <slot name="bottom"></slot>
      </div>
    </div>
    <div class="modal__overlay" @click.prevent.stop="onClose" :class="{'js-active': isOpen}"></div>
  </div>
</template>

<script>
  export default {
    name: "UiModal",

    data() {
      return {
        isOpen: false
      }
    },

    props: {
      name: {
        type: String,
        default: ''
      },

      isActive: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      onClose() {
        this.$emit('close', this.name)
      }
    },

    watch: {
      isActive(isOpen) {
        this.isOpen = isOpen
      }
    }
  }
</script>
